import { useEffect } from "react";
import { styles } from "./styles";
import { useAuth0 } from "@auth0/auth0-react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../Loading";
import { Box, Button } from "@mui/material";

const PricingTable = (): JSX.Element => {
  const { user, logout } = useAuth0();
  const pricingTableId = process.env.REACT_APP_PRICING_TABLE_ID;
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={styles.logoutMainContainer}>
      <Box sx={styles.logoutContainer}>
        <Button
          onClick={() => {
            logout({
              logoutParams: {
                returnTo: window.location.origin + "/logout",
              },
            });
            sessionStorage.clear();
            localStorage.clear();
          }}
          sx={styles.logoutButton}
        >
          Logout
        </Button>
      </Box>
      <h1 style={styles.selectOptionHeading}>Select a Subscription Option</h1>
      <div style={{ marginBottom: 50 }}>
        <stripe-pricing-table
          pricing-table-id={pricingTableId}
          publishable-key={publishableKey}
          customer-email={user?.email}
        ></stripe-pricing-table>
      </div>
    </Box>
  );
};

export default withAuthenticationRequired(PricingTable, {
  onRedirecting: () => <Loading />,
});
